import { organizationDocumentMaxFileSizeBytes } from '@/shared/lib/organization-document-limits'

const proofFileMimeTypes = new Set([
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
])

const proofFileExtensions = new Set(['pdf', 'xls', 'xlsx'])

export const supplierInstallationEmissionReportProofFileAccept =
  '.pdf,.xls,.xlsx,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export function isSupplierInstallationEmissionReportProofFileTypeValid(file: File) {
  if (proofFileMimeTypes.has(file.type)) {
    return true
  }

  const extension = file.name.split('.').pop()?.toLowerCase()
  return extension !== undefined && proofFileExtensions.has(extension)
}

export function isSupplierInstallationEmissionReportProofFileSizeValid(file: File) {
  return file.size <= organizationDocumentMaxFileSizeBytes
}

export function isSupplierInstallationEmissionReportProofFileValid(file: File) {
  return (
    isSupplierInstallationEmissionReportProofFileTypeValid(file) &&
    isSupplierInstallationEmissionReportProofFileSizeValid(file)
  )
}
